






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

import PerformanceActivitiesService from '@/api/PerformanceActivitiesService';

import FilterByCampaigns from '@/componentsV2/organisms/FilterByCampaigns/FilterByCampaigns.vue';

import Typography from '@/components/atoms/Typography/Typography.vue';

import { ICampaign } from '@/models/performance';
import DateUtils from '@/utils/DateUtils';
import { SpecialOfferTypeEnum } from '@/models/offer';

type OfferTypeVariant = 'General' | 'Birthday' | 'SpecialCoinOffers';

@Component({
  components: {
    AnalyticsCardList,
    FilterByCampaigns,
    Typography
  }
})
export default class ActivitiesOverviewDealsDiscountsAndBirthdayClub extends Vue {
  @Prop() filters!: Record<string, any>;
  @Prop() offerType!: OfferTypeVariant;
  @Prop({ default: true }) showRequestLoading?: boolean;

  performanceActivitiesService: PerformanceActivitiesService = new PerformanceActivitiesService();

  reports: Array<any> = [];

  campaigns: Array<ICampaign> = [];
  selectedCampaign: any = '';
  initSelectedCampaign: string = '';

  specialTypeLabelMapper: Record<SpecialOfferTypeEnum, string> = {
    [SpecialOfferTypeEnum.STOREWIDE]: 'Storewide deal',
    [SpecialOfferTypeEnum.PRODUCT_AND_SERVICE]: 'Specific product / service',
    [SpecialOfferTypeEnum.BIRTHDAY]: 'Birthday offer',
    [SpecialOfferTypeEnum.TWO_FOR_ONE]: '2 for 1'
  };

  analytics: Record<string, AnalyticsCardListItem> = {
    offerViews: {
      infos: {
        title: 'Offer views',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 0
      }
    },
    savedOffer: {
      infos: {
        title: 'Saved offer',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 0
      }
    },
    redeemedOffer: {
      infos: {
        title: 'Redeemed offer',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 0
      }
    }
  };

  get analyticsInstanceId() {
    const mapper: Record<OfferTypeVariant, string> = {
      General: 'activities-analytcs-general',
      Birthday: 'activities-analytcs-birthday',
      SpecialCoinOffers: 'activities-analytcs-special'
    };

    return mapper[this.offerType];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    const mapper: Record<OfferTypeVariant, string> = {
      General: `performance.activities.campaignActivity.tabs.dealsDiscounts`,
      Birthday: `performance.activities.campaignActivity.tabs.birthdayClub`,
      SpecialCoinOffers: `performance.activities.campaignActivity.tabs.specialCoins`
    };

    return mapper[this.offerType];
  }

  get linkSeeAll() {
    const mapper: Record<OfferTypeVariant, string> = {
      General: '/offers',
      Birthday: '/birthday-club',
      SpecialCoinOffers: '/special-coins-offers'
    };

    return mapper[this.offerType];
  }

  get translatedAnalytics() {
    return Object.entries(this.analytics)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.${key}.tooltip`)
        }
      }))
      .filter(({ hidden }) => !hidden);
  }

  get campaignsOptions() {
    const mapperCampaignsOptions = this.campaigns.map((campaign: ICampaign) => {
      return {
        value: campaign.id,
        label: campaign.name
      };
    });

    return mapperCampaignsOptions;
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  @Watch('filters')
  async getOverview() {
    if (this.showRequestLoading) {
      this.$showLoaderWithLocker();
    }

    this.clearData();

    let endpointPath = `/v2/admin/offer/reports`;

    const allFilters = { ...this.filters };

    const response = await this.performanceActivitiesService.getActivitiesOverview(
      endpointPath,
      allFilters
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const data = response.data.item[0] ? response.data.item[0] : {};

    response.data.item.map((offer: any) => {
      const { campaignId, offerTitle, expirationOffer, specialType } = offer;

      this.campaigns.push({
        id: campaignId,
        name: offerTitle,
        specialType:
          specialType &&
          this.specialTypeLabelMapper[specialType as SpecialOfferTypeEnum],
        expirationOffer: expirationOffer
          ? DateUtils.formattedDate({ date: expirationOffer })
          : ''
      });

      this.reports[campaignId] = offer;

      if (!this.initSelectedCampaign) {
        this.initSelectedCampaign = campaignId;

        this.handleFilterByCampaign(this.initSelectedCampaign);
      }
    });
  }

  handleFilterByCampaign(campaign: any) {
    this.selectedCampaign = this.campaigns.find(item => item.id === campaign);

    this.handleAnalyticsList();
  }

  handleAnalyticsList() {
    const { offerViews, redeemOffer, savedOffer } = this.reports[
      this.selectedCampaign.id
    ];
    this.analytics.offerViews.infos.amount = offerViews;
    this.analytics.savedOffer.infos.amount = savedOffer;
    this.analytics.redeemedOffer.infos.amount = redeemOffer;
  }

  clearData() {
    this.reports = [];
    this.campaigns = [];
    this.initSelectedCampaign = '';
    this.selectedCampaign = '';
    this.analytics.offerViews.infos.amount = 0;
    this.analytics.savedOffer.infos.amount = 0;
    this.analytics.redeemedOffer.infos.amount = 0;
  }

  mounted() {
    setTimeout(() => this.getOverview(), 0);
  }
}
